import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next'; // Добавьте это
import styled from 'styled-components';
import { Container } from '../styles/styled';

import UnifiedApiImage from '../images/UnifiedAPILayer.png';
import SmartFXImage from '../images/SmartFXRouting.png';
import RegulatoryComplianceImage from '../images/RegulatoryAligned.png';
import OperationalAnalyticsImage from '../images/ModularArchitecture.png';

const KeyFeaturesWrapper = styled.section`
  padding: 80px 0;

  > div {
    .badge {
      opacity: 0;
      transform: translateX(-20px);
      transition: opacity 0.6s ease-out, transform 0.6s ease-out;

      @media (max-width: 768px) {
        margin: 0 auto -20px;
        display: block;
      }
    }

    h2 {
      font-size: 36px;
      color: #002DFF;
      margin-bottom: 20px;
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease-out, transform 0.6s ease-out;

      @media (max-width: 1024px) {
        font-size: 30px;
      }

      @media (max-width: 768px) {
        font-size: 26px;
      }
    }

    .list {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      gap: 40px;

      .item {
        padding: 20px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 30px;
        opacity: 0;
        transform: translateY(30px);
        transition: opacity 0.7s ease-out, transform 0.7s ease-out;
        background: #f8f9ff;

        @media (max-width: 1024px) {
          column-gap: 20px;
        }

        @media (max-width: 768px) {
          flex-direction: column;
          text-align: center;
          padding: 25px;
        }

        img {
          max-width: 280px;
          height: auto;
          border-radius: 8px;
          transform: scale(0.9);
          transition: transform 0.7s ease-out;

          @media (max-width: 1024px) {
            max-width: 220px;
          }

          @media (max-width: 768px) {
            max-width: 70%;
            margin-top: 15px;
          }
        }

        h3 {
          font-size: 24px;
          color: #002DFF;
          margin-bottom: 10px;

          @media (max-width: 1024px) {
            font-size: 22px;
          }

          @media (max-width: 768px) {
            font-size: 20px;
          }
        }

        p {
          font-size: 16px;
          color: #555;
          line-height: 1.5;

          @media (max-width: 768px) {
            font-size: 15px;
          }
        }
      }
    }
  }

  /* Анимация появления */
  &.visible {
    .badge {
      opacity: 1;
      transform: translateX(0);
      transition-delay: 0.1s;
    }

    h2 {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.2s;
    }

    .list .item {
      opacity: 1;
      transform: translateY(0);

      img {
        transform: scale(1);
      }

      &:nth-child(1) {
        transition-delay: 0.3s;
      }

      &:nth-child(2) {
        transition-delay: 0.5s;
      }

      &:nth-child(3) {
        transition-delay: 0.7s;
      }

      &:nth-child(4) {
        transition-delay: 0.9s;
      }
    }
  }
`;

const KeyFeatures = () => {
  const { t } = useTranslation('common'); // Добавьте это
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <KeyFeaturesWrapper ref={sectionRef}>
      <Container>
        <span
          className="badge"
          style={{
            backgroundColor: '#78FFD6',
            height: 'fit-content',
            borderRadius: '8px',
            display: 'block',
            width: '140px',
            color: '#78FFD6',
            fontSize: '37px',
            marginBottom: '-45px',
            marginLeft: '-10px',
          }}
        >
          S
        </span>
        <h2>{t('keyFeatures.title')}</h2>

        <div className="list">
          <div className="item">
            <div>
              <h3>{t('keyFeatures.unifiedApi.title')}</h3>
              <p>{t('keyFeatures.unifiedApi.description')}</p>
            </div>
            <img src={UnifiedApiImage} alt={t('keyFeatures.unifiedApi.alt')} />
          </div>

          <div className="item">
            <img src={SmartFXImage} alt={t('keyFeatures.smartFx.alt')} />
            <div>
              <h3>{t('keyFeatures.smartFx.title')}</h3>
              <p>{t('keyFeatures.smartFx.description')}</p>
            </div>
          </div>

          <div className="item">
            <div>
              <h3>{t('keyFeatures.regulatory.title')}</h3>
              <p>{t('keyFeatures.regulatory.description')}</p>
            </div>
            <img src={RegulatoryComplianceImage} alt={t('keyFeatures.regulatory.alt')} />
          </div>

          <div className="item">
            <img src={OperationalAnalyticsImage} alt={t('keyFeatures.operational.alt')} />
            <div>
              <h3>{t('keyFeatures.operational.title')}</h3>
              <p>{t('keyFeatures.operational.description')}</p>
            </div>
          </div>
        </div>
      </Container>
    </KeyFeaturesWrapper>
  );
};

export default KeyFeatures;